import React, { Component } from "react";
import { connect } from "react-redux";

import Aux1 from "../Aux1/Aux1";
import Login from "../../components/Launch/Login";
import PG from "../../components/PG/PG";
import MainLogin from "../../containers/Auth/Auth";
import Bottomnav from "../../components/BottomMobileMenu/BottomMobileMenu";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";

// const urlArray = ["/", "/loader", "/onelogin"];
const urlArray = ["/","/istifada","/onelogin"];

class Layout extends Component {
  state = {
    showSideDrawer: false,
  };

  sideDrawerClosedHandler = () => {
    this.setState({ showSideDrawer: false });
  };

  sideDrawerToggleHandler = () => {
    this.setState((prevState) => {
      return { showSideDrawer: !prevState.showSideDrawer };
    });
  };

  render() {
    if (this.props.isAuthenticated) {
      return (
        <Aux1>
          <Header />
          {this.props.children} <Footer />
          <Bottomnav />
        </Aux1>
      );
    } 
     else if (
      urlArray.find(
        (x) => x === this.props.children._owner.pendingProps.location.pathname
      ) === undefined &&
      (localStorage.token === undefined || localStorage.token === "")
    ) {
      localStorage.setItem(
        "templink",
        this.props.children._owner.pendingProps.location.pathname.replace(
          "#",
          ""
        )
      );
      return (
        <Aux1>
          <Login></Login>
        </Aux1>
      );
    } 
    else {
      return (
        <Aux1>
          <MainLogin></MainLogin>
        </Aux1>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.token !== null,
  };
};

export default connect(mapStateToProps)(Layout);
